export default __webpack_public_path__ + "static/media/wood3.f70169b4.jpg";